// Cloudflare Turnstile captcha for the public forms (sign up, login, school registration, contact us).
// The backend (CaptchaFilter) checks the token sent in the x-captcha-token header.
// Leave REACT_APP_TURNSTILE_SITE_KEY empty to switch the widget off (the backend must then be off too).

export const TURNSTILE_SITE_KEY = (process.env.REACT_APP_TURNSTILE_SITE_KEY || "").trim();
export const CAPTCHA_HEADER = "x-captcha-token";
export const CAPTCHA_ERROR_MESSAGE = "Security check did not complete. Please wait a moment and try again, or refresh the page.";

const SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let scriptPromise = null;

export const isCaptchaEnabled = () => Boolean(TURNSTILE_SITE_KEY);

export function loadTurnstile() {
	if (window.turnstile) return Promise.resolve(window.turnstile);
	if (!scriptPromise) {
		scriptPromise = new Promise((resolve, reject) => {
			const script = document.createElement("script");
			script.src = SCRIPT_URL;
			script.async = true;
			script.defer = true;
			script.onload = () => (window.turnstile ? resolve(window.turnstile) : reject(new Error("turnstile-missing")));
			script.onerror = () => {
				scriptPromise = null; // allow a retry on the next mount
				reject(new Error("turnstile-load-failed"));
			};
			document.head.appendChild(script);
		});
	}
	return scriptPromise;
}

/** Headers to add to a protected API call. Empty when captcha is switched off. */
export const captchaHeaders = (token) => (token ? { [CAPTCHA_HEADER]: token } : {});
